import React, { useEffect, useState } from 'react'
import { isParalympic } from 'helpers/utils'
import NotAvailable from 'components/common/NotAvailable'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly'

function  Redirect() {
  // State to store the HTTP status code
  const [status, setStatus] = useState(false)
  const { mirs_competition } = useUrlFriendlyToParameters()

  let href = window?.location?.href

  if (isParalympic(mirs_competition)){
    href = window?.location?.href?.replace('en/paris-2024-paralympics', 'en/paris-2024/paralympic-games')?.replace('fr/paris-2024-paralympics', 'fr/paris-2024/jeux-paralympiques')
  }

  useEffect(() => {
    // Function to check the status of the current URL
    const checkStatus = async () => {
      try {
        // Perform a HEAD request to the current URL
        const response = await fetch(href, {
          method: 'HEAD', // Use HEAD to only get headers without the response body
        })
        if (response.ok) {
          setStatus(true) // Update state if the response is 200 OK
        } else {
          setStatus(false) // Save the status code if it's not 200
        }
      } catch (error) {
        setStatus(false) // Handle any errors as a server error (500)
      }
    }

    // Call the function to check the status
    checkStatus()
  }, []) // Empty dependency array means this runs once after the component mounts

  //If status is true, reload the page with the modified URL
  if (status) {
    console.log('INFO redirection to ' + href)
    window.location.href = href
    return <></> 
  }

  console.log('WARNING url not found: ' + href)
  return <NotAvailable label={'LabelNoDataAvailable'} />
}

export default Redirect
